import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LayoutWithSidebar from 'components/v2/LayoutWithSidebar';
import ShipperSettings from 'components/modules/user/shipper/ShipperSettings';
import ReferenceNumbers from 'components/modules/user/shipper/ReferenceNumbers';
import { CONFIGURED_FEATURES, featureEnabled } from 'helpers/feature-flags';
import { getCustomerV2 } from 'utils/CustomersAPIUtils';

const ReferenceNumbersPage = () => {
  const { t } = useTranslation();
  const [user, setUser] = useState();
  const params = useParams();
  const id = params.id;

  async function fetchUser() {
    const user = await getCustomerV2(id);
    setUser(user);
  }

  useEffect(() => {
    fetchUser();
  }, []);

  function renderSidebar() {
    return <ShipperSettings activePage="reference-numbers" userId={id} />;
  }

  const breadcrumbs = {
    pages: [
      {
        name: user?.company_name || t('SHIPPER'),
        href: `/users/${id}`,
        current: false,
      },
      {
        name: t('REFERENCE_NUMBERS'),
        href: `/users/${id}/settings/reference-numbers`,
        current: true,
      },
    ],
  };
  return (
    <LayoutWithSidebar
      title={t('REFERENCE_NUMBERS')}
      sidebar={renderSidebar}
      breadcrumbs={breadcrumbs}
      className="py-4"
    >
      <div className="w-full">
        {featureEnabled(CONFIGURED_FEATURES.SSR) && (
          <ReferenceNumbers id={id} />
        )}
      </div>
    </LayoutWithSidebar>
  );
};

export default ReferenceNumbersPage;
